import { useEffect, useState } from "react"
import CallAPI, { CallAPIform } from "../api";
import Swal from "sweetalert2";


export default function useControlUser(canViewList){
    const [list,setList]=useState([]);
    const [page,setpage]=useState(1);
    const [loading,setloading]=useState(false);
    const [account,setaccount]=useState({});
    const [photo,setphoto]=useState();
    useEffect(()=>{
   if(canViewList){
    setloading(true);
    CallAPI("user/list")
    .then(res=>setList(res.data))
    .catch(err=>console.log(err))
    .finally(()=>setloading(false))
   }
    },[])

    const handleChange=(field,value)=>{
        setaccount(prev=>{
            let obj={...prev};
            obj[field]=value;
            return obj;
        })
    }
    const create=async ()=>{
        setloading(true);
        try {
            const form=new FormData();
            for(let el in account)
            if(account[el].trim().length!==0)
            form.append(el,account[el]);
            if(photo)
            form.append('photo',photo);
          const res=await CallAPIform("user/create","post",form);
          setList(prev=>[res.data,...prev]);  
          Swal.fire("success","user added",'success');
        } catch (error) {
            console.log(error);
        }
        setloading(false);
    }

    const changeDp=(e)=>{
        if(e.target.files[0])
        setphoto(e.target.files[0]);
    }
  
    return {list,loading,account,handleChange,create,changeDp};
}